module.exports = __webpack_public_path__ + "img/user-happer.3be4844c.png";